/**
 * Map semantic tone keys ('error'|'warning'|'info'|'success') — as returned by
 * @learnzapp/core/readiness diagnosticInsights — to theme tokens. Single
 * shared mapping so web and mobile chips/gauges render identically; the apps
 * previously carried per-platform copies that had already diverged.
 *
 * @param {Object} theme getColorTheme() output
 * @param {string} tone  'error' | 'warning' | 'info' | 'success'
 * @returns {{ color: string, bg: string }}
 */
export function getToneColors(theme, tone) {
  switch (tone) {
    case 'success':
      return { color: theme?.primary?.green?.[500], bg: theme?.primary?.green?.[100] };
    case 'info':
      return { color: theme?.primary?.blue?.[500], bg: theme?.primary?.blue?.[100] };
    case 'warning':
      return {
        color: theme?.primary?.orange?.[500] || theme?.semantic?.warning,
        bg: theme?.primary?.orange?.[100] || theme?.primary?.gray?.[100],
      };
    case 'error':
    default:
      return {
        color: theme?.primary?.red?.[500] || theme?.semantic?.error,
        bg: theme?.primary?.red?.[50],
      };
  }
}
